import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { DEPOSIT_STATUS } from "../../../../Utils/DepositUtil";

// Always the status in words as well as colour.
const DepositStatusBadge = ({ status, className }) => {
  const { t } = useTranslation();
  const style = DEPOSIT_STATUS[status];
  if (!style) return null;
  return (
    <span
      className={clsx(
        "inline-flex whitespace-nowrap rounded-full px-2 text-xs font-semibold leading-5",
        style.className,
        className,
      )}
    >
      {t(style.label)}
    </span>
  );
};

export default DepositStatusBadge;
